/**
 * Drizzle ORM Schema definitions for rn-equote Local Database
 */
import { sqliteTable, text, integer } from 'drizzle-orm/sqlite-core';

/** Bảng Khách hàng & Người phụ thuộc */
export const customersTable = sqliteTable('customers', {
  id: text('id').primaryKey(),
  name: text('name').notNull(),
  category: text('category').notNull(), // 'main' | 'dependent'
  dependentsCount: integer('dependents_count').notNull().default(0),
  dob: text('dob').notNull(),
  age: integer('age').notNull(),
  gender: text('gender').notNull(),
  phone: text('phone').notNull(),
  email: text('email').notNull(),
  labels: text('labels').notNull(), // JSON stringified CustomerLabel[]
  occupation: text('occupation').notNull(),
  createdAt: text('created_at').notNull(),
  updatedAt: text('updated_at').notNull(),
  isLocal: integer('is_local', { mode: 'boolean' }).notNull().default(true),
});

/** Bảng Ghi chú CRM Khách hàng */
export const notesTable = sqliteTable('customer_notes', {
  id: text('id').primaryKey(),
  customerId: text('customer_id').notNull(),
  type: text('type').notNull(), // 'journal' | 'gift' | 'claims'
  content: text('content').notNull(),
  author: text('author').notNull(),
  date: text('date').notNull(),
  createdAt: text('created_at').notNull(),
  updatedAt: text('updated_at').notNull(),
});

/** Bảng Bản thảo Minh họa Bảo hiểm */
export const illustrationsTable = sqliteTable('illustrations', {
  id: text('id').primaryKey(),
  customerId: text('customer_id').notNull(),
  proposalName: text('proposal_name').notNull(),
  productCode: text('product_code').notNull(), // 'XUM' | 'XPQ' | 'XTL'
  customerName: text('customer_name').notNull(),
  customerAge: integer('customer_age').notNull(),
  customerGender: text('customer_gender').notNull(),
  sumAssured: text('sum_assured').notNull(),
  term: integer('term').notNull(),
  freq: text('freq').notNull(),
  premium: text('premium').notNull(),
  stage: text('stage').notNull(), // 'new' | 'negotiating' | 'closed'
  lastUpdated: text('last_updated').notNull(),
  expiryDate: text('expiry_date').notNull(),
  selectedRiders: text('selected_riders').notNull(), // JSON stringified array
  topUpAmount: integer('top_up_amount').notNull().default(0),
  createdAt: text('created_at').notNull(),
  updatedAt: text('updated_at').notNull(),
});

/** Bảng Hợp đồng Bảo hiểm đã phát hành */
export const contractsTable = sqliteTable('contracts', {
  id: text('id').primaryKey(),
  contractNumber: text('contract_number').notNull(),
  customerId: text('customer_id').notNull(),
  customerName: text('customer_name').notNull(),
  productName: text('product_name').notNull(),
  sumAssured: text('sum_assured').notNull(),
  annualPremium: text('annual_premium').notNull(),
  effectiveDate: text('effective_date').notNull(),
  status: text('status').notNull(), // 'active' | 'pending' | 'lapsed' | 'matured'
  createdAt: text('created_at').notNull(),
  updatedAt: text('updated_at').notNull(),
});

export type CustomerDbRecord = typeof customersTable.$inferSelect;
export type NoteDbRecord = typeof notesTable.$inferSelect;
export type IllustrationDbRecord = typeof illustrationsTable.$inferSelect;
export type ContractDbRecord = typeof contractsTable.$inferSelect;
